import { render, staticRenderFns } from "./SewagePlantInoutConfForm.vue?vue&type=template&id=23dc5304&"
import script from "./SewagePlantInoutConfForm.vue?vue&type=script&lang=js&"
export * from "./SewagePlantInoutConfForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports